import { getApiErrorCode, getApiErrorMessage } from '@repo/api'
import { isResponseError } from '@repo/upfetch'

/** A Saved View API failure as concise product copy, never the raw payload. */
export const productError = (error: Error) => {
  if (isResponseError(error) && getApiErrorCode(error) === 'saved_view_owner_required') {
    return 'Only the owner can change this view.'
  }
  if (isResponseError(error) && error.status === 404) return 'This Saved View no longer exists.'
  return getApiErrorMessage(error, 'The Saved View could not be saved.')[0].message
}
